export default __webpack_public_path__ + "static/media/aboutUs1.6a9db037.webp";